<template>
  <div class="h-full">
    <div class="flex tab-header">
      <div
        v-for="tab in listTab"
        :key="tab.tabKey"
        @click="tabActive(tab)"
        class="ms-tab"
        :class="{'tabActived':tab == tabActived}"
      >{{tab.title}}</div>
    </div>
    <template v-for="tab in listTabRender">
      <div class="tab-item" :key="tab.tabKey" v-show="tab == tabActived">
        <components :tabActived="tabActived" :is="tab.component" :initData="tab.initData"></components>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: "MsTab",
  props: {
    listTab: {
      default: () => [],
      type: Array
    },
    tabActived:{
      default: null,
      type: Object
    }

  },
  created() {
    const me = this;
    me.tabActived ? me.tabActive(me.tabActived) : me.tabActive(me.listTab[0]);
  },
  data() {
    return {
      listTabRender: []
    };
  },
  methods: {
    //Sự kiện ấn vào chọn tab
    tabActive(tab) {
      const me = this;
      me.tabActived = tab;
      if (!me.listTabRender.includes(tab)) {
        me.listTabRender.push(tab);
      }
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/controls/_variables.scss";
.tabActived {
  font-weight: bold;
  border-bottom: 3px solid var(--tab-border);
  color: var(--tab-color) !important;
}
.ms-tab {
  padding: 10px 20px;
  height: 42px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
}
.tab-header {
  border-bottom: 1px solid #eaedf3;
  height: 42px;
}
.tab-item {
  height: calc(100% - 42px);
  overflow-y: auto;
}
</style>
